import getColorByText from './getColorByText';
import _ from 'lodash';
import { ENTITY_TYPE_FILTER, ENTITY_VALUE_FILTER } from '../../const/logFilters';
import escapeHtml from './escapeHtml';

function getContentWithChunks(msg = '', entitiesSource, classes, hideChunkType, filtered, filteredEntities) {
    var res = _.isString(msg) ? msg : '';
    var textAsArr = res.split('');
    var chunk;
    var entities;
    var chunkType;
    var chunkValue;
    var chunkTypeTooltip = '';
    var chunkValueTooltip = '';
    var chunkTypeFilterAttr = '';
    var chunkTextFilterAttr = '';
    var klass = classes ? classes : 'highlighted-text';
    var hasHighlighting = false;

    try {
        if (!_.isEmpty(entitiesSource)) {
            if (_.isString(entitiesSource)) {
                entities = JSON.parse(entitiesSource);
            } else {
                entities = entitiesSource;
            }

            if (entities && entities.length > 0) {
                hasHighlighting = true;
                res = '';
                for (var i = 0; i < textAsArr.length; i++) {
                    chunk = _.find(entities, { index: i });
                    if (chunk) {
                        var typeFilterIcon = filtered ? `<i class="icon icon-alan-filter-unfilled chunk-filter-icon"></i>` : '';
                        var textFilterIcon = filtered ? `<i class="icon icon-alan-filter-unfilled chunk-filter-icon"></i>` : '';

                        chunkTypeFilterAttr = filtered ? `data-filter-key="chunk-type" data-filter-value="${chunk.type}"` : '';
                        chunkTypeTooltip = filtered ? `title="Filter by entity type: ${chunk.type}"` : '';

                        if (!!_.find(filteredEntities, { [ENTITY_TYPE_FILTER]: chunk.type })) {
                            typeFilterIcon = '<i class="icon icon-alan-filter chunk-filter-icon"></i>';
                        }

                        if (!!_.find(filteredEntities, { [ENTITY_VALUE_FILTER]: `${chunk.type}_${chunk.value}` })) {
                            textFilterIcon = '<i class="icon icon-alan-filter chunk-filter-icon"></i>';
                        }

                        chunkType = hideChunkType !== true ? (`<span style="text-transform: uppercase" class="highlighted-type" ${chunkTypeFilterAttr} ${chunkTypeTooltip}>${chunk.type}${typeFilterIcon}</span>`) : '';
                        chunkTextFilterAttr = filtered ? `data-filter-key="chunk-text" data-filter-value="${chunk.type}_${chunk.value}"` : '';
                        chunkValueTooltip = filtered ? `title="Filter by entity: ${chunk.value}"` : '';
                        chunkValue = `<span class="highlighted-text-val" ${chunkTextFilterAttr} ${chunkValueTooltip}>${chunk.value}${textFilterIcon}</span>`;
                        res += `<span style="background-color:${getColorByText(chunk.type, .8)};" class="${klass}">${chunkValue} ${chunkType}</span>`;
                        i = i + chunk.value.length - 1;
                    } else {
                        res += textAsArr[i];
                    }
                }
            }
        }
    } catch (err) {
        console.error('Cannot parse entitiesAll property', entitiesSource);
    }

    return { __html: hasHighlighting ? res : escapeHtml(res) };
}

export default getContentWithChunks;